module.exports = __webpack_public_path__ + "media/images/flags/1x1/mco-1693e36d4482f4c6932f070f9345bc2f.svg";